import api from '../../../utils/api'
import { useState, useEffect } from "react"

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

import ConfigBudgetForm from './Form/ConfigBudgetForm'

function DefaultConfigBudget({ btCancelAction }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [config, setConfig] = useState({})
    const [load, setLoad] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "budget_config")

    /* get all function */
    const getAll = () => {
        api.get(`/proposal/config/get`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setConfig(response.data.proposal_config)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    const submit = async (info) => {
        let msgType = 'success'
        const data = await api.patch(`proposal/config/update`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    if (!load) return null

    /* PAGE */
    return (
        myPermissionEdit
            ? <ConfigBudgetForm dataConfig={config} handleOnSubmit={submit} btCancelAction={btCancelAction} />
            : <div>Sem permissão</div>
    )
}

export default DefaultConfigBudget
